const slicedReducers = ["loadingBar", "form", "router"];

const combineReducers = (reducers) => {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i += 1) {
    const key = reducerKeys[i];
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }

  const finalReducerKeys = Object.keys(finalReducers);

  return function combination(state, action) {
    let hasChanged = false;
    let nextState = state || {};
    for (let i = 0; i < finalReducerKeys.length; i += 1) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      let previousStateForKey = nextState;
      if (slicedReducers.indexOf(key) !== -1) {
        previousStateForKey = nextState[key];
      }
      const nextStateForKey = reducer(previousStateForKey, action);
      if (slicedReducers.indexOf(key) !== -1) {
        nextState[key] = nextStateForKey;
      } else {
        nextState = { ...nextState, ...nextStateForKey };
      }

      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
};

export default combineReducers;
